import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Label } from '../ui/label';
import { Users, Building2 } from 'lucide-react';

const BulkAssignModal = ({
  open,
  onClose,
  selectedCount,
  users,
  selectedUserId,
  onUserChange,
  onAssign
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Users className="w-5 h-5" />
            Bulk Assign Clients
          </DialogTitle>
          <DialogDescription>
            Assign {selectedCount} selected client(s) to a user
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <div className="flex items-center gap-2 mb-4 p-3 bg-emerald-50 rounded-lg">
            <Building2 className="w-5 h-5 text-emerald-600" />
            <span className="font-medium">{selectedCount} client(s) selected</span>
          </div>

          <Label htmlFor="assign-user">Assign to User</Label>
          <Select value={selectedUserId} onValueChange={onUserChange}>
            <SelectTrigger className="mt-1" data-testid="assign-user-select">
              <SelectValue placeholder="Select a user" />
            </SelectTrigger>
            <SelectContent>
              {users.length === 0 ? (
                <SelectItem value="none" disabled>No users available</SelectItem>
              ) : (
                users.map(user => (
                  <SelectItem key={user.id} value={user.id}>
                    <div className="flex items-center gap-2">
                      <span>{user.full_name || user.email}</span>
                      <span className="text-xs text-slate-500">({user.role})</span>
                    </div>
                  </SelectItem>
                ))
              )}
            </SelectContent>
          </Select>
          <p className="text-xs text-slate-500 mt-2">
            These clients will be added to the user's existing assigned clients
          </p>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button 
            onClick={onAssign} 
            disabled={!selectedUserId}
            data-testid="confirm-assign-btn"
          >
            Assign Clients
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BulkAssignModal;
